import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { DropDownListModule } from "@progress/kendo-angular-dropdowns";
import { PopoverModule } from "ngx-popover";
import { CalendarioModule } from "../../../../shared/components/calendario/calendario.module";
import { PipesModule } from "../../../../shared/_pipes/pipes.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { SearchModule } from "../../buscador/search.module";
import { IdentificationDataComponent } from "./identification-data.component";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        SearchModule,
        DropDownListModule,
        PopoverModule,
        PipesModule,
        DirectivesModule,
        CalendarioModule
    ],
    declarations: [
        IdentificationDataComponent
    ],
    exports: [
        IdentificationDataComponent
    ]
})
export class IdentificationDataModule { }
